/*
 * @Author: cc
 * @Date: 2020-09-29 15:29:22
 * @LastEditTime: 2020-10-19 20:14:04
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\trsJsonToString\trsJsonToString.js
 * @Description: 
 */
/* Create by BaiZhiming*/
'use strict';
angular.module('util.JsonArrayToString', [])
    . factory('jsonArrayToStringService', function() {
        return {
            jsonArrayToString: function(json) {
                for (var obj in json) {
                    if (json[obj] instanceof Array || json[obj] instanceof Object) {
                        json[obj] = JSON.stringify(json[obj]);
                    }
                }
                return json;
            },
            clearEmptyObjects: function(array, property) { // 通过判断数组中某个对象元素的某个属性的值是否为空，来删除该数组中的该对象。
                var i = 0;
                while (i < array.length) {
                    if (array[i][property] === '') {
                        array.splice(i, 1);
                    } else {
                        i++;
                    }
                }
                return array;
            },

            /**
         * [deleteAttribute description]删除对象中多余的属性
         * @param  {[obj]} array    [description]对象集合
         * @param  {[attr]} property [description]要删除的属性
         * @return {[obj]}          [description]删除属性后的对象
         */
            deleteAttribute: function(array, property) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][property]) {
                        delete array[i][property];
                    }
                }
                return array;
            },

            /**
         * [clearEmptyArray description]清除空数组 专门为列表图片准备
         * @param  {[type]} array [description]
         * @return {[type]}       [description]
         */
            clearEmptyArray: function(array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i].length < 1) {
                        array.splice(i, 1);
                        i--;
                    }
                }
                return array;
            }
        };
    });
